//-------------------Shooping Cart------------------------------//
const disclaimerTrigger = $('.cart--singleProd #disclaimerTrigger'),
      subscribeMode = $('.cart--singleProd #subscribeMode');

//- Select Subscribe option if click on disclaimer box title
disclaimerTrigger.on("click", function () {
    let checkbox = $('.cart--singleProd #subscribeCheckbox');
    let cartBtn = $('.cart--singleProd #cartCta');

    checkbox.toggleClass('checked');
    cartBtn.toggleClass('disabled');
})

function agreeToSS(status) {
    let checkbox = $('.cart--singleProd #subscribeCheckbox');
    let cartBtn = $('.cart--singleProd #cartCta');

    if (status) {
        checkbox.addClass('checked');
        cartBtn.removeClass('disabled');

    } else {
        checkbox.removeClass('checked');
        cartBtn.addClass('disabled');
    }
}

// close disclaimer box
$('#closeDisclaimer').on('click', function () {
    $('.cart--singleProd #disclaimerBox').removeClass('subscribe-box__disclaimer--open');
});

// activate subscribe prices
$('.cart--singleProd .subscribe-box__default').on('click', function () {
    let thisBtn = $(this),
        cartBtn = $('.cart--singleProd #cartCta'),
        checkbox = $('.cart--singleProd #subscribeCheckbox'),
        disclaimerBox = $('.cart--singleProd #disclaimerBox'),
        subscribeMode = $('.cart--singleProd #subscribeMode');

    $('.cart--singleProd .subscribe-box__default').removeClass('active');
    thisBtn.addClass('active');

    disclaimerBox.addClass('subscribe-box__disclaimer--open');

    //- reset all UIs
    if (cartBtn.hasClass('disabled')) {
        cartBtn.removeClass('disabled');
    }

    if (checkbox.hasClass('checked')) {
        checkbox.removeClass('checked');
    }

    if (thisBtn.hasClass('subscribe')) {
        subscribeMode.attr('data-subscribe', 'true');

        if ($(body).hasClass('show-promoBanner')) {
            $(body).addClass('show-promoBanner--subscribe');
        }

        if (!cartBtn.hasClass('disabled')) {
            cartBtn.addClass('disabled');
        }

        if (!disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
            disclaimerBox.addClass('subscribe-box__disclaimer--open');
        }

    } else {
        subscribeMode.attr('data-subscribe', 'false');

        if ($(body).hasClass('show-promoBanner--subscribe')) {
            $(body).removeClass('show-promoBanner--subscribe');
        }

        if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
            disclaimerBox.removeClass('subscribe-box__disclaimer--open');
        }
    }
    
    $('.cart--singleProd .cart__product.active').trigger("click");
});

/**
* Subscribe Mode - checkbox mode
*/
$('.cart--singleProd .purchaseMode__input').on('click', function (check) {
    // console.log($(this).is(":checked"));

    let checkboxType,
        disclaimerBox = $('.cart--singleProd #disclaimerBox');
        // subscribeMode = $('.cart--singleProd #subscribeMode');

    if (subscribeMode.attr('data-subscribe') === 'false') {
        // $('#orderNow').attr('data-subscribe', 'true');
        subscribeMode.attr('data-subscribe', 'true');
        checkboxType = true;
        disclaimerBox.addClass('subscribe-box__disclaimer--open');

    } else {
        // $('#orderNow').attr('data-subscribe', 'false');
        subscribeMode.attr('data-subscribe', 'false');
        checkboxType = false;

        // on touch screens
        if (disclaimerBox.hasClass('subscribe-box__disclaimer--open')) {
            disclaimerBox.removeClass('subscribe-box__disclaimer--open');
        }
    }

    this.setAttribute('checked', checkboxType);

    $('.cart--singleProd .cart__product.active').trigger("click");
});

//set prices   
function activeProduct() {
    let thisProduct = $(this);
    let subscribeModeAttr = $('.cart--singleProd #subscribeMode').attr('data-subscribe');

    let price = '-price',
        link = '-link',
        ship = '-shipping',
        alternativeContentValue,
        regularity = '',
        subscribe = '',
        sale = '';

    if (subscribeModeAttr === 'true') {
        regularity = '<span>/month</span>';
        subscribe = '-subscribe'

        if ($('.cart--singleProd #alternativeContent').length) {
            alternativeContentValue = '';
        }
    } else {
        if ($('.cart--singleProd #alternativeContent').length) {
            alternativeContentValue = $('.cart--singleProd #alternativeContent').attr('data-alt-content');
        }
    }

    if ($('body').hasClass('show-promoBanner')) {
        sale = '-sale'

    }

    $('.cart--singleProd .cart__product').removeClass('active');

    thisProduct.addClass('active');

    // if (thisProduct.attr('data-units') === "6" && subscribeModeAttr === 'subscribe') {
    //     $('.cart--singleProd .perJar .value').html(parseFloat(
    //         (thisProduct.attr('data' + price)) / (thisProduct.attr('data-units')) + 0.01
    //     ).toFixed(2));
    // } else {
        $('.cart--singleProd .perJar .value').html(parseFloat(
            (thisProduct.attr('data' + sale + subscribe + price)) / (thisProduct.attr('data-units'))
        ).toFixed(2));
    // }

    $('.cart--singleProd .current .value').html(thisProduct.attr('data' + sale + subscribe + price) + regularity);
    $('.cart--singleProd .retailPrice .value').html(thisProduct.attr('data-retail'));
    $('.cart--singleProd .shipping .value').html(thisProduct.attr('data' + subscribe + ship));
    $('.cart--singleProd .cart__image div:not(.cart__imgsrc):not(.cart__gift)').removeClass('show').addClass('hide');
    $('.cart--singleProd .cart__image .' + thisProduct.attr('data-units') + "").removeClass('hide').addClass('show');

    if ($('.cart--singleProd #alternativeContent').length) {
        $('.cart--singleProd #alternativeContent').html(' ' + alternativeContentValue);
    }

    let param = $('.cart--singleProd .cta').attr('data-param');

    if (thisProduct.attr('data' + sale + subscribe + link).includes('?') == false) {
        param = '?' + param
    } else {
        param = '&' + param
    }

    $('.cart--singleProd .cta').attr('href', thisProduct.attr('data' + sale + subscribe + link) + param);
};

$('.cart--singleProd .cart__product').on('click', activeProduct);
$('.cart--singleProd .cart__product.active').trigger("click");
//------------------ End Shooping Cart-------------------------//